//Componentes generales
import React, { useContext, useReducer } from "react";
import proveedoresReducer from "./proveedoresReducer";
import proveedoresContext from "./proveedoresContext";

//Socket
import { SocketContext } from "../socket/socket";

//Axios
import clienteAxios from "../../config/axios";

//Rutas de api
import { getProviders, uploadProvider } from "../../api/abmProvider"

//Acciones
import { 
    ACTUALIZAR_PROVEEDORES,
    ACTUALIZAR_PROVEEDORES_DB,
    CARGANDO_PROV,
    ERROR_PROV,
    LIMPIAR_ERROR
} from "./proveedoresActions";

/* 
    State encargado de la gestión de proveedores.
*/
const ProveedoresState = props => {

    const server = useContext(SocketContext);

    //Valores iniciales
    const initialState = {
        proveedores: [],
        // Arranca en true: todavía no se hizo la carga inicial, evita mostrar
        // "No hay registros" antes de que llegue la respuesta del servidor.
        cargando: true,
        error: ""
    };

    const [state, dispatch] = useReducer(proveedoresReducer, initialState);

    /* 
        Función recuperar los proveedores y a su vez actualizarlos.
    */
    const actualizarProveedores = async () => {

        try{
            console.log("ENTRO AL ACTUALIZAR PROVEEDORES");
            const resp = await getProviders();
            dispatch({
                type: ACTUALIZAR_PROVEEDORES,
                payload: resp.data.data
            })
            console.log("RESPUESTA DE PROVEEDORES SQL",resp)
            return resp.data.data;

        }catch(error){
            console.log(error);
        }
    }

    /* 
        Función encargada de sobreescribir la tabla de proveedores con la propia de Softland.
            Donde userID es el ID del usuario en sesión.
                  userName es el nombre del usuario en sesión.
    */
    const actualizarProveedoresDB = async (userID, userName) => {

        try{
            console.log("ENTRO AL ACTUALIZAR PROVEEDORES DB");
            // El endpoint solo confirma que el proceso arrancó en segundo plano;
            // hay que esperar el aviso por socket para saber el resultado real.
            await uploadProvider(userID, userName);

            if (!server) {
                throw new Error("No hay conexión en tiempo real disponible. Recargue la página e intente nuevamente.");
            }

            const resultado = await new Promise((resolve) => {
                server.once("actualizarProveedoresFinalizado", resolve);
            });

            if (resultado.status !== 200) {
                dispatch({
                    type: ERROR_PROV,
                    payload: resultado.message
                });
                return {status: false, msg: resultado.message};
            }

            const resp = await getProviders();
            dispatch({
                type: ACTUALIZAR_PROVEEDORES_DB,
                payload: resp.data.data
            });
            console.log("RESPUESTA DE PROVEEDORES MONGO",resp)
        return {status: true, msg: "Se actualizo con exito la base de datos."};

        }catch(error){
            console.log(error);
            const errMsg = error?.response?.data?.errMsg || error.message;
            dispatch({
                type: ERROR_PROV,
                payload: errMsg
            });

            return {status: false, msg: errMsg};
        }
    }

    const cargando =  () => {
        dispatch({
            type: CARGANDO_PROV
        })
    }

    const limpiarError = () => {
        dispatch({
            type: LIMPIAR_ERROR
        })
    }

    return(
        <proveedoresContext.Provider
            value={{
                proveedores: state.proveedores,
                isCargando: state.cargando,
                error: state.error,
                actualizarProveedores,
                actualizarProveedoresDB,
                cargando,
                limpiarError
            }}
        >

            {props.children}

        </proveedoresContext.Provider>
    )
    
}

export default ProveedoresState;